import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'
import { TextBody } from '../../styles/vars/textStyles.style'
import { easings } from '../../styles/vars/easings.style'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { ContainerMain } from '../Container/index.style'
import { grid } from '../../styles/vars/grid.style'

export const CarouselModalInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  ${clamp('padding-bottom', 20, 40, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-top', 60, 100, breakpoints.mobile, breakpoints.contained)}
`

export const CarouselModal = styled.div`
  display: block;
  height: 100vh;
  height: calc(var(--vh) * 100);
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 20;

  &:before {
    background-color: ${colors.darkBlue};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: scaleY(0);
    transform-origin: 0% 0%;
    transition: transform 0.6s ${easings.in.quart};
    z-index: 1;
  }

  ${ContainerMain} {
    height: 100%;
    position: relative;
    width: 100%;
    z-index: 2;
  }

  ${({ modalIsOpen }) => {
    return modalIsOpen === true
      ? `
      pointer-events: all;  
      transition: none;
      visibility: visible;

      &:before {
        transform: scaleY(1);
        transition: transform 1s ${easings.out.quart};
      }
      `
      : `
        pointer-events: none;
        transition: visibility 0s .6s;
        visibility: hidden;
      `
  }}
`

export const CarouselImage = styled.img`
  border-radius: 0.6rem;
  height: 100%;
  object-fit: cover;
  position: relative;
  transform: translateY(105%);
  transition: transform 0s 0.5s;
  width: 100%;
`

export const CarouselImageWrap = styled.div`
  border-radius: 0.6rem;
  height: 100%;
  overflow: hidden;
  position: relative;
  opacity: 0;
  transition: opacity 0.5s, transform 0s 0.5s;
  transform: translateY(-105%);

  ${props =>
    props.visible &&
    `
    opacity: 1;
    transform: translateY(0);
    transition: transform 1s ${easings.out.quart};

    ${CarouselImage} {
      opacity: 1;
      transform: translateY(0);
      transition: transform 1s ${easings.out.quart}
    }
  `}
`

export const CarouselContent = styled.div`
  ${clamp('padding-top', grid.gap.min, grid.gap.max)}
  ${TextBody} {
    color: ${colors.light};
  }
  opacity: 0;
  transition: opacity 0.5s;

  ${CarouselModal}[data-inview="true"] & {
    opacity: 1;
    transition: none;
  }
`

export const CloseButton = styled.button`
  border: 0.1rem solid ${colors.light};
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 5rem;
  opacity: 0;
  position: relative;
  margin-left: auto;
  transform: rotate(45deg);
  transform-origin: center center;
  width: 5rem;

  ${mq.desk} {
    margin: 2.7rem 0 0;
    margin-left: auto;
  }

  ${props =>
    props.visible &&
    `
    opacity: 1;
    transition: opacity .5s ${easings.out.quart} .5s;
  `}

  span {
    background: ${colors.light};
    display: inline-block;
    height: 0.1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    transform-origin: center center;
    width: 2.6rem;

    &:nth-of-type(1) {
      transform: translateX(-50%) translateY(-50%) rotate(90deg);
    }
  }
`
